<spinner [spinnerShow]="spinnerShow"></spinner>
<div class="clearfix">
    <button class="btn btn-w-m btn-primary pull-right" type="button" (click)="synchronizeFolder()">
        <i  class="fa fa-refresh"></i> Synchronize
    </button>
</div>

<div *ngIf="importList.length > 0">
    <h4>List Synchronization</h4>
    <div class="table-responsive" style="height: 300px;">
        <table class="table">
            <thead>
            <tr>
                <th>Date</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of importList">
                <td>{{item.createdAt | date:'short'}}</td>
                <td>
                    <div [ngSwitch]="item.status">
                        <span *ngSwitchCase="'done'">Done</span>
                        <span *ngSwitchCase="'in_progress'">In Progress</span>
                        <span *ngSwitchCase="'wait'">Wait</span>
                        <span *ngSwitchDefault>{{item.status}}</span>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/condomanager/condomanager.component.html